import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {RegionEntity} from "@ots-frontend/ots-data";
import {useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";

export type RegionAction = "IMPLEMENT_ME"

export type RegionActionMenuDropdownProps = {
  region: RegionEntity
  onActionClick?: (action: RegionAction) => void
}

export const RegionActionMenuDropdown = (props: RegionActionMenuDropdownProps) => {
  const {region} = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const actions: Set<RegionAction> = useMemo(() => {
    const actions = new Set<RegionAction>()
    return actions
  }, [region, hasAccess])

  return (
    <>
      {actions.size === 0 &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
    </>
  )
}
